import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  return <section className="py-12 md:py-20 px-6 max-w-3xl mx-auto text-[#3D3631]" data-id="element-43">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="space-y-8" data-id="element-44">
        {/* Opening Lead */}
        <div className="font-serif italic text-xl md:text-2xl leading-relaxed text-[#5C544E] border-l-4 border-[#E8DDD0] pl-6 py-2" data-id="element-45">
          <p className="mb-4" data-id="element-46">
            Hay un momento que casi nadie dice en voz alta.
          </p>
          <p className="mb-4" data-id="element-47">
            Ese segundo cuando te levantas de la silla… y antes de dar el primer
            paso, tu mano busca algo: el respaldo, la pared, el mueble.
          </p>
          <p className="mb-4" data-id="element-48">
            No porque «quieras». Porque tu cuerpo ya aprendió a desconfiar.
          </p>
          <p data-id="element-49">
            Y lo peor no es el tropiezo. Lo peor es lo que viene después:
            empezar a moverte menos, salir menos, pedir más ayuda, sentir que tu
            casa —tu propia casa— te está ganando.
          </p>
        </div>

        {/* Headlines */}
        <div className="text-center py-8 space-y-6" data-id="element-50">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#2A6B6B] leading-tight" data-id="element-51">
            30 días para caminar por tu casa sin agarrarte de los muebles.
          </h1>
          <p className="text-xl md:text-2xl text-[#3D3631] font-medium" data-id="element-52">
            El plan de 7 minutos que te devuelve confianza al pararte de la
            silla.
          </p>
        </div>

        {/* Product Image */}
        <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-white transform rotate-1 hover:rotate-0 transition-transform duration-700" data-id="element-53">
          <img src="https://cdn.magicpatterns.com/uploads/2ry7nArDHngoimiLLM639m/estabilidad_y_equilibrio_652B.png" alt="Mujer mayor sonriendo mientras lee la guía de estabilidad en una tablet" className="w-full h-auto object-cover" data-id="element-54" />
        </div>

        {/* Sub-hero text */}
        <p className="text-xl md:text-2xl leading-relaxed text-center font-medium text-[#2A6B6B] pt-6" data-id="element-55">
          Esta guía existe para una sola cosa: devolverle a tu cuerpo la
          práctica diaria de estabilidad… sin gimnasio, sin saltos, sin rutinas
          que te dan miedo.
        </p>

        {/* CTA button to pricing */}
        <div className="flex justify-center pt-4" data-id="element-56">
          <a href="#precio" className="inline-flex items-center gap-2 bg-[#D4654A] hover:bg-[#C0563D] hover:scale-105 transition-all duration-300 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg" data-id="element-57">
            VER OFERTA ESPECIAL
            <ArrowDown className="h-5 w-5" data-id="element-58" />
          </a>
        </div>
      </motion.div>
    </section>;
}